module.exports = __webpack_public_path__ + "img/prize-card.6d351328.png";